import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { AssetsService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Assets } from '../../models'

const log = new Logger('AssetTypeDetailResolver')
@Injectable({ providedIn: 'root' })
export class AssetDetailResolver implements Resolve<Observable<Assets>> {
  constructor(private assetsService: AssetsService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let aid = route.params['aid']
    
    return this.assetsService.getDetail(aid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['asset']))
    )
  }
}
